import { useMemo } from 'react';
import { prop, path } from 'ramda';
import { getCookie } from 'js/utils/cookie.util';
import { useAppSelector, useCookieSettingsSelector } from 'js/store/hooks';

export const useCommonCookie = () => {
    const defaultCookieName = useCookieSettingsSelector(prop('defaultCookieName'));
    const commonCookieName = useAppSelector(path(['cookiesConfiguration', 'commonCookieName']));
    const cookie = getCookie(commonCookieName || defaultCookieName);

    return useMemo(() => cookie, [cookie]);
};
